export default "__VITE_ASSET__ByvzSQnD__"